import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { PollyManageDataService } from '../polly-manage-data-service/polly-manage-data.service';
import { UserResponse, UserRole } from 'polly-commons';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PollyManageBackendService } from '../polly-manage-backend-service/polly-manage-backend.service';

@Injectable({
  providedIn: 'root',
})
export class PollyManageRoleGuardService  {
  constructor(
    private readonly router: Router,
    private readonly manageDataService: PollyManageDataService,
    private readonly pollyManageBackendService: PollyManageBackendService
  ) {}

  public canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    const userRole: UserRole | null = this.manageDataService.getCurrentUserRole();
    if (userRole) {
      return routeSnapshot.data.role.includes(userRole.attributes.role_name);
    } else {
      return this.pollyManageBackendService.getCurrentUserInfo().pipe(
        map((userInfo: UserResponse) => {
          this.manageDataService.userInfo = userInfo;
          this.manageDataService.currentUserInfo = userInfo.data;
          if (userInfo.included && userInfo.included.length) {
            const orgInfo = userInfo.included.find(item => item.type === 'organizations');
            if (orgInfo) {
              this.manageDataService.currentUserOrganization = {
                org_id: Number(orgInfo.id),
                org_name: orgInfo.attributes.name
              };
            }
            const licenseInfo = userInfo.included.find(item => item.type === 'licenses');
            if (licenseInfo) {
              this.manageDataService.currentUserLicenseInfo = licenseInfo;
            }
            const roleInfo = userInfo.included.find(item => item.type === 'roles');
            if (roleInfo) {
              const currentUserRole: UserRole = roleInfo;
              this.manageDataService.currentUserRole = currentUserRole;
              if (currentUserRole) {
                return routeSnapshot.data.role.includes(currentUserRole.attributes.role_name);
              } else {
                this.router.navigate(['/manage/atlas']);
                return false;
              }
            }
          }
          return false;
        })
      );
    }
  }
}
